import React from 'react'
import { StyleProp, View, ViewStyle } from 'react-native'
import { useTheme } from '@ui-kitten/components'
import { StyleService, useStyleSheet } from '@src/style/service'
import { Text, Icon } from '../base'

interface PromoBadgeProps {
  badgeText?: string
  size?: number
  style?: StyleProp<ViewStyle>
  fontSize?: number
}

export const PromoBadge = (props: PromoBadgeProps) => {
  const { badgeText, size = 56, style, fontSize = 13 } = props
  const styles = useStyleSheet(themedStyle)
  const theme = useTheme()

  return (
    <View style={[styles.badgeContainer, { width: size, height: size }, style]}>
      <Icon name="seal" size={size} weight="fill" color={theme['theme.tooltip.link']} />
      <Text
        type="small"
        bold
        style={[styles.badgeText, { fontSize, lineHeight: fontSize }]}
        adjustsFontSizeToFit
      >
        {badgeText}
      </Text>
    </View>
  )
}

const themedStyle = StyleService.create({
  badgeContainer: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  badgeText: {
    position: 'absolute',
    textAlign: 'center',
    color: 'theme.solid.white',
  },
})
